import { render, staticRenderFns } from "./ManagementSubnets.vue?vue&type=template&id=49d0fed3&scoped=true&"
import script from "./ManagementSubnets.vue?vue&type=script&lang=ts&"
export * from "./ManagementSubnets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d0fed3",
  null
  
)

export default component.exports